/**
 * Where an authored solo clip's hands touch the body or the ground. The clip carries the pose as it was made on one body; the animator then
 * reaches the hand onto the real contact on the body playing it (its own knee or head), so the touch lands on every body and
 * height. Each contact holds from `from` to `to` (clip seconds) and eases on and off over `CONTACT_EASE` on either side.
 */
export interface SoloContact {
  hand: 'left' | 'right';
  /**
   * `knee`: the palm on that side's knee cap, fingers forward over it. `head`: the wrist where `at` puts it in the head joint's frame (metres
   * on the male's head, scaled to each body's head). `floor`: the hand lifted just enough to keep the fingers above the ground, for a body
   * whose arms are longer than the clip's; never pulled down.
   */
  on: 'knee' | 'head' | 'floor';
  at?: readonly [number, number, number];
  from: number;
  to: number;
}
export const CONTACT_EASE = .45;

export const SOLO_CONTACTS: Record<string, SoloContact[]> = {
  'fidget-ground': [
    { hand: 'left', on: 'knee', from: 1.4, to: 3.9 },
    { hand: 'right', on: 'floor', from: 1.5, to: 2.3 },
    { hand: 'right', on: 'knee', from: 3.5, to: 3.9 },
  ],
  // The fingers on the crown just behind the top of the head, as on the male the clip was made on.
  'fidget-scratch': [{ hand: 'right', on: 'head', at: [.074, .114, -.098], from: 1.0, to: 2.5 }],
};
/** The male's head scale, which the `head` offsets are measured on. */
export const CONTACT_HEAD_SCALE = 1.086;
